<template>
    <div style="height:120px;" ref="chartdiv">
    </div>
</template>
  
<script>
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import colorLib from '../../util/colorLib';
import axios from 'axios';
import dayjs from 'dayjs';

export default {
    name: 'HealthProgress_ProgressChart',
    props: {
        startDate: {
            type: String
        },
        endDate: {
            type: String
        },
        unit: {
            type: String
        },
        interval:{
            type:Object
        }
    },
    data() {
        return {
        };
    },

    methods: {
        getColor(o) {
            return am5.color(colorLib.getAlarmColorByOrder(o));
        },
        async loadData() {
            this.loading = true;
            var urlString = `${process.env.VUE_APP_APIURL}/dashboard/health-progress`;

            try {
                let resp = await axios
                    .get(urlString, { params: { start: this.startDate, end: this.endDate, unit: this.unit } });
                if (resp.status == 200) {
                    let data = resp.data;
                    if (this.root) {
                        this.root.dispose();
                    }
                    let root = am5.Root.new(this.$refs.chartdiv);
                    this.root = root;
                    root.setThemes([am5themes_Animated.new(root)]);


                    // Create chart
                    // https://www.amcharts.com/docs/v5/charts/xy-chart/
                    let chart = root.container.children.push(am5xy.XYChart.new(root, {
                        panX: false,
                        panY: false,
                        layout: root.verticalLayout
                    }));


                    // Add legend
                    // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
                    chart.children.push(
                        am5.Legend.new(root, {
                            centerX: am5.p50,
                            x: am5.p50
                        })
                    );



                    // Create axes
                    // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
                    let yAxis = chart.yAxes.push(am5xy.CategoryAxis.new(root, {
                        categoryField: "category",
                        renderer: am5xy.AxisRendererY.new(root, {})
                    }));
                    yAxis.data.setAll([{ category: "" }]);


                    var dateAxis = am5xy.DateAxis.new(root, {
                        min: dayjs(this.startDate).toDate(),
                        max: dayjs(this.endDate).toDate(),
                        baseInterval: { timeUnit: this.interval.chartIntervalUnit, count: 2 },
                        renderer: am5xy.AxisRendererX.new(root, {})
                    });
                    dateAxis.get("renderer").labels.template.set("forceHidden", true);

                    var xAxis = chart.xAxes.push(dateAxis);


                    // Add series
                    // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
                    let series = chart.series.push(am5xy.ColumnSeries.new(root, {
                        xAxis: xAxis,
                        yAxis: yAxis,
                        openValueXField: "start",
                        valueXField: "end",
                        categoryYField: "category"
                    }));

                    series.columns.template.setAll({
                        strokeWidth: 0,
                        strokeOpacity: 0,
                        height: am5.percent(100),
                        templateField: "columnSettings"
                    });

                    data = data.map(x => {
                        return {
                            start: dayjs(x.start).toDate().getTime(),
                            end: dayjs(x.end).toDate().getTime(),
                            category: "",
                            columnSettings: {
                                fill: this.getColor(x.order)
                            }
                        };
                    });
                    series.data.setAll(data);



                    // Create axis ranges for each column
                    //https://www.amcharts.com/docs/v5/charts/xy-chart/axes/axis-ranges/
                    for (var i = 0; i < data.length; i++) {
                        let rangeDataItem = xAxis.makeDataItem({
                            value: data[i].start
                        });

                        let range = xAxis.createAxisRange(rangeDataItem);

                        rangeDataItem.get("grid").set("forceHidden", true);

                        rangeDataItem.get("tick").setAll({
                            visible: true,
                            length: 15,
                            strokeOpacity: 0.2
                        });

                        rangeDataItem.get("label").setAll({
                            centerX: am5.p0,
                            forceHidden: false,
                            fontSize: 12,
                            text: dayjs(new Date(data[i].start)).format(this.interval.format)
                        });
                    }
                    // Make stuff animate on load
                    // https://www.amcharts.com/docs/v5/concepts/animations/


                    // Add legend
                    // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
                    let legend = chart.children.push(am5.Legend.new(root, {
                        nameField: "name",
                        fillField: "color",
                        strokeField: "color",
                        centerX: am5.percent(50),
                        x: am5.percent(50),
                        clickTarget: "none"
                    }));


                    legend.data.setAll([{
                        name: this.$t("common.healthy"),
                        color: am5.color(colorLib.color.healthy)
                    }, {
                        name: this.$t("common.attention"),
                        color: am5.color(colorLib.color.attention)
                    }, {
                        name: this.$t("common.hazard"),
                        color: am5.color(colorLib.color.hazard)
                    }, {
                        name: this.$t("common.critical"),
                        color: am5.color(colorLib.color.critical)
                    },
                    {
                        name: this.$t("common.anomaly"),
                        color: am5.color(colorLib.color.detection)
                    },
                    {
                        name: this.$t("common.unknown"),
                        color: am5.color(colorLib.color.unknown)
                    }]);
                    this.legend = legend;
                    // this.series.appear();
                    // this.chart.appear(1000, 100);


                } else {
                    console.log("Error loading data");
                }
            } catch (error) {
                console.log(error);
            }
            this.loading = false;
        }
    },
    mounted() {
        this.loadData();
    },

    beforeDestroy() {
        if (this.root) {
            this.root.dispose();
        }
    },
    watch: {
        startDate: function () {
            this.loadData();
        },
        deep: true,
    }
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#pager .el-carousel__arrow {
    width: 10px;
    height: 10px
}
</style>